import database from '../../system/model/firebase/firebase';
import { palette } from '../../system/styles/styles';
import { platformTypes } from '../reducer/platformReducer';
import { companyLogin, setCompany, setVacancies } from './auth_actions';
import { getCompanyUsers, getTemplateEmail } from './company_action';

export const startSetPlatform = (platformName) => async (dispatch) => {
  try {
    const data = (await database.collection(`${platformName}`).doc('data').get()).data();
    document.documentElement.style.setProperty('--button-color', data.primaryColor);
    document.documentElement.style.setProperty('--link-color', data.primaryColor);
    palette.customColor = data.primaryColor;
    dispatch({
      type: platformTypes.FETCH_PLATFORM_DATA,
      payload: data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const dataGet = () => (dispatch, getState) => {
  console.log(getState());
};

export const startSetCompany = () => async (dispatch, getState) => {
  try {
    const { uid } = getState().auth;
    const { platformName } = getState().platform;
    const ref = database.collection(`${platformName}/data/companies/`).doc(uid);
    const data = await ref.get();
    if (data.exists) {
      const jobs = [];
      const infoJobs = await ref.collection('jobs').get();
      infoJobs.forEach((doc) => jobs.push(doc.data()));
      dispatch(setVacancies(jobs));
      dispatch(getCompanyUsers(uid));
      dispatch(getTemplateEmail());
      dispatch(setCompany(data.data()));
    } else {
      const user = await database.collection(platformName).doc('data').collection('companiesUsers').doc(uid).get();
      const objectID = user.data().objectID;
      const companyData = (await database.collection(`${platformName}/data/companies`).doc(objectID).get()).data();
      const infoJobs = await database.collection(`${platformName}/data/companies/${objectID}/jobs`).get();
      const jobs = [];
      infoJobs.forEach((doc) => jobs.push(doc.data()));
      dispatch(setCompany(companyData));
      dispatch(companyLogin(objectID, 'company'));
      dispatch(setVacancies(jobs));
      dispatch(getCompanyUsers(objectID));
    }
  } catch (e) {
    console.error(e);
  }
};
